import { createContext } from 'react';
import { NodeEdgeMapper } from '@iotv/datamodel';
import { Networks as NetworksEnumProxy, Milliseconds } from '@iotv/iotv-v3-types';
import { addResultReducer } from './reducers/requestStatusReducer';
import dayjs from 'dayjs';
import { getNodeEdgeMapperReducer } from '../../ContextProviders/NodeEdgeMapperComponentContext';
import { setAreaDataReducer, setAreasReducer, setBoundsReducer, setCoverageTargetsReducer, setLineDefiningPairsReducer, setNetworksReducer, setParametersReducer, setPlacesReducer, setPropertiesReducer, } from './reducers/networkCoverageReducer';
import { setWizardAllowBackReducer, setWizardAllowNextReducer, setWizardStepReducer, } from './reducers/coverageWizardReducer';
// Find initial time based on default range (3 hrs)
const rangeLength = 3;
const unit = 'hour';
const initialToTime = dayjs().set('second', 0).set('millisecond', 0);
const toDateMs = initialToTime.unix() * Milliseconds.SECOND;
const fromDateMs = initialToTime.subtract(rangeLength, unit).unix() * Milliseconds.SECOND;
export const defaultNetworkCoverageState = {
    apexNode: null,
    nodeEdgeMapper: new NodeEdgeMapper(),
    nemHash: '',
    Properties: [],
    Areas: [],
    areaData: [],
    lineDefiningPairs: [],
    Places: [],
    Networks: [NetworksEnumProxy.ThingPark, NetworksEnumProxy.Chirpstack, NetworksEnumProxy.AWS_LPWAN, NetworksEnumProxy.TTN_Enterprise],
    Gateways: [],
    parameters: {
        timePeriod: { fromDateMs, toDateMs },
        distanceFromPointMeters: 50,
    },
    bounds: undefined,
    activeStep: 0,
    allowBack: false,
    allowNext: false,
    lineColorMetricAttribute: 'esp',
    receptionAreaColorMetricAttribute: 'esp',
    requestStatusMap: {},
};
const nemReducer = getNodeEdgeMapperReducer({ canaryString: 'networkCoverageNemReducer' });
export const NetworkCoverageReducer = (prev, update) => {
    switch (update.type) {
        /* Nem Reducer Actions */
        case 'setApexNode':
        case 'removeItems':
        case 'loadNEMContents':
        case 'clearNEMContents':
        case 'loadItems': {
            const nemState = { apexNode: prev.apexNode, nemHash: prev.nemHash, nodeEdgeMapper: prev.nodeEdgeMapper };
            return { ...prev, ...nemReducer(nemState, update) };
        }
        /* General Network Data Actions */
        case 'setBounds': {
            return setBoundsReducer(prev, update);
        }
        case 'setNetworks': {
            return setNetworksReducer(prev, update);
        }
        case 'setParameters': {
            return setParametersReducer(prev, update);
        }
        case 'setAreaData': {
            return setAreaDataReducer(prev, update);
        }
        case 'setCoverageTargets': {
            return setCoverageTargetsReducer(prev, update);
        }
        case 'setProperties': {
            return setPropertiesReducer(prev, update);
        }
        case 'setAreas': {
            return setAreasReducer(prev, update);
        }
        case 'setPlaces': {
            return setPlacesReducer(prev, update);
        }
        case 'setLineDefiningPairs': {
            return setLineDefiningPairsReducer(prev, update);
        }
        /* Wizard Status Actions */
        case 'setWizardStep': {
            return setWizardStepReducer(prev, update);
        }
        case 'setWizardAllowNext': {
            return setWizardAllowNextReducer(prev, update);
        }
        case 'setWizardAllowBack': {
            return setWizardAllowBackReducer(prev, update);
        }
        /* Request Status Actions */
        case 'addCoverageResult': {
            return addResultReducer(prev, update);
        }
    }
    return prev;
};
export const NetworkCoverageContext = createContext({
    state: defaultNetworkCoverageState,
    dispatch: () => (prev, update) => {
        throw new Error('Please do not use the default network context reducer. This reducer should only be used with values provided (ideally from a reducer using Network Coverage Reducer)');
    },
});
